export interface CoverageFeeProductInput {
  vendor?: string | null;
  sku?: string | null;
  title?: string | null;
}

export enum CoverageFeeProductMatchType {
  REDO_ONLY = "redo_only",
  REDO_AND_COMPETITORS = "redo_and_competitors",
}

export function isCoverageFeeProduct(args: {
  product: CoverageFeeProductInput;
  matchType?: CoverageFeeProductMatchType;
}): boolean {
  const { product, matchType = CoverageFeeProductMatchType.REDO_ONLY } = args;
  const vendor = product.vendor?.toLowerCase().trim() ?? "";
  const sku = product.sku?.toLowerCase() ?? "";
  const title = product.title?.toLowerCase() ?? "";

  if (
    /^re:?do$/.test(vendor) ||
    sku.startsWith("x-redo") ||
    title.includes("re:do") ||
    title.includes("redo fee")
  ) {
    return true;
  }

  if (
    matchType === CoverageFeeProductMatchType.REDO_AND_COMPETITORS &&
    (/route-/i.test(sku) ||
      /routeins/i.test(sku) ||
      vendor === "order protection" ||
      /insurance|package\s+protection|order\s+protection/i.test(title))
  ) {
    return true;
  }

  return false;
}
